import React, { useMemo } from 'react'
import { mutualTheme } from '~/utils/theme'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { CircledText } from '~/components/'
import { useLocation } from 'react-router'
import { formatToNormalizedUrl } from '~/utils/format'
import clsx from 'clsx'

const useStyles = makeStyles({
  responsiveSteps: {
    display: 'flex',
    height: '50px',
    width: '100vw',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f8f8',
    position: 'absolute',
    left: '0',
    top: '0'
  },
  stepSeparator: {
    backgroundColor: '#DFDFDF',
    width: '8px',
    height: '2px',
    marginRight: '4px',
    marginLeft: '4px'
  },
  subStep: {
    width: 5,
    height: 5,
    borderRadius: '50%',
    backgroundColor: '#C4C4C4'
  },
  activedSeparator: {
    backgroundColor: mutualTheme.palette.blue.main
  },
  completedSubStep: {
    backgroundColor: '#05C370'
  }
})

export const ResponsiveStepIndicator = () => {
  const classes = useStyles()
  const location = useLocation()

  const isFirstPage = useMemo(() => formatToNormalizedUrl(location.pathname) === '/register', [location])
  const isSecondPage = useMemo(() => formatToNormalizedUrl(location.pathname) === '/register/company-info', [location])
  const isThirdPage = useMemo(() => formatToNormalizedUrl(location.pathname) === '/register/loan-info', [location])
  const isFourthPage = useMemo(() => formatToNormalizedUrl(location.pathname) === '/register/create-account', [location])
  const isFeedbackPage = useMemo(() => formatToNormalizedUrl(location.pathname).includes('/register/feedback'), [location])

  const renderResult = (
    <Box sx={{
      zIndex: '2'
    }}
    className={classes.responsiveSteps}>
      <CircledText
        circleText='1'
        disabled={false}
        finished={isSecondPage || isThirdPage || isFourthPage || isFeedbackPage}
      />
      <Box className={clsx(classes.stepSeparator, {
        [classes.activedSeparator]: isSecondPage || isThirdPage || isFourthPage || isFeedbackPage
      })} />
      <CircledText
        circleText='2'
        disabled={isFirstPage}
        finished={isThirdPage || isFourthPage || isFeedbackPage}
      />
      <Box className={clsx(classes.stepSeparator, {
        [classes.activedSeparator]: isThirdPage || isFourthPage || isFeedbackPage
      })} />
      <CircledText
        circleText='3'
        disabled={isFirstPage || isSecondPage}
        finished={isFourthPage || isFeedbackPage}
      />
      <Box className={clsx(classes.stepSeparator, {
        [classes.activedSeparator]: isFourthPage || isFeedbackPage
      })} />
      <CircledText
        circleText='4'
        disabled={isFirstPage || isSecondPage || isThirdPage}
        finished={isFeedbackPage}
      />
    </Box>
  )

  return (
    <>
      {renderResult}
    </>
  )
}
